import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { authFetch } from "../utils/authFetch";

export default function SiteViewPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    authFetch(
  `${process.env.REACT_APP_API_URL}/site-full-details/${id}`
)
      .then((res) => res.json())
      .then((data) => {
        setData(data);
        setLoading(false);
      })
      .catch((err) => {
        console.error("Error fetching site details:", err);
        setLoading(false);
      });
  }, [id]);

  if (loading) return <div style={styles.center}>Loading Site Infrastructure Portfolio...</div>;
  if (!data || !data.site) return <div style={styles.center}>Site Profile Not Found.</div>;

  const { site, team } = data;

  return (
    <div style={styles.container}>
      {/* Top Bar Navigation Actions */}
      <div style={styles.headerRow}>
        <button onClick={() => navigate(-1)} style={styles.backBtn}>← Back to Projects</button>
        <span style={{ ...styles.badge, backgroundColor: site.status === 'Active' ? '#2e7d32' : '#c62828' }}>
          {site.status}
        </span>
      </div>

      <h1 style={styles.mainTitle}>{site.site_name}</h1>
      <p style={styles.subtitle}><strong style={{color:'#666'}}>Project Code:</strong> {site.project_code || "—"}</p>
      <p style={styles.subtitle}><strong style={{color:'#666'}}>City Location:</strong> {site.city || "Not Specified"}</p>

      <div style={styles.dashboardGrid}>
        
        {/* 📌 BLOCK A: CONTRACT MASTER METRICS */}
        <div style={styles.card}>
          <h2 style={styles.cardTitle}>📋 Structural & Financial Parameters</h2>
          <hr style={styles.divider} />
          
          <table style={styles.table}>
            <tbody>
              <tr>
                <td style={styles.label}>Project Valuation:</td>
                <td style={styles.val}>₹ {Number(site.project_value).toLocaleString('en-IN')}</td>
              </tr>
              <tr>
                <td style={styles.label}>GST Number Identification:</td>
                <td style={styles.val}>{site.gst_number || "N/A"}</td>
              </tr>
              <tr>
                <td style={styles.label}>Corporate Delivery Address:</td>
                <td style={styles.val}>{site.address || "N/A"}</td>
              </tr>
              <tr>
                <td style={styles.label}>Mobilization (Start Date):</td>
                <td style={styles.val}>{site.start_date ? new Date(site.start_date).toLocaleDateString() : "Pending"}</td>
              </tr>
              <tr>
                <td style={styles.label}>Target Handover (End Date):</td>
                <td style={styles.val}>{site.end_date ? new Date(site.end_date).toLocaleDateString() : "Pending"}</td>
              </tr>
            </tbody>
          </table>
        </div>

        {/* 📌 BLOCK B: CLIENT OPERATIONS CONTACTS */}
        <div style={styles.card}>
          <h2 style={styles.cardTitle}>👥 Client  Communications</h2>
          <hr style={styles.divider} />

          <div style={styles.contactSection}>
            <h5 style={styles.contactSub}>Primary Contact</h5>
            <p><b>Name:</b> {site.contact_person1_name || "N/A"}</p>
            <p><b>Mobile:</b> {site.contact_person1_number || "N/A"}</p>
            <p><b>Email:</b> {site.contact_person1_email || "N/A"}</p>
          </div>

          {site.contact_person2_name && (
            <div style={{...styles.contactSection, marginTop: "15px"}}>
              <h5 style={styles.contactSub}>Secondary  Contact</h5>
              <p><b>Name:</b> {site.contact_person2_name}</p>
              <p><b>Mobile:</b> {site.contact_person2_number || "N/A"}</p>
              <p><b>Email:</b> {site.contact_person2_email || "N/A"}</p>
            </div>
          )}
        </div>

      </div>

      {/* 📌 BLOCK C: EIMS PROJECT MANAGERIAL TEAM STRUCTURE */}
      <div style={{...styles.card, marginTop: "25px"}}>
        <h2 style={styles.cardTitle}>🏗️ Assigned Project Allocation Matrix (EIMS Team)</h2>
        <hr style={styles.divider} />

        {team ? (
          <div style={styles.teamGrid}>
            <div style={styles.teamNode}>
              <span style={styles.roleLabel}><b>Project Manager</b></span>
              <p style={styles.personName}>{team.project_manager || "Unassigned"}</p>
            </div>
            <div style={styles.teamNode}>
              <span style={styles.roleLabel}><b>On-Site Supervisor</b></span>
              <p style={styles.personName}>{team.supervisor || "Unassigned"}</p>
            </div>
            <div style={styles.teamNode}>
              <span style={styles.roleLabel}><b>2D & 3D Designers</b></span>
              <p style={styles.personName}>{team.designers || "Unassigned"}</p>
            </div>
            <div style={styles.teamNode}>
              <span style={styles.roleLabel}><b>Sourcing & Procurement (Purchasers)</b></span>
              <p style={styles.personName}>{team.purchasers || "Unassigned"}</p>
            </div>
            <div style={styles.teamNode}>
              <span style={styles.roleLabel}><b>Billing & Commercial Accountant</b></span>
              <p style={styles.personName}>{team.accountant || "Unassigned"}</p>
            </div>
          </div>
        ) : (
          <div style={styles.noTeamAlert}>
            ⚠️ No corporate workforce deployment records initialized for this site partition yet.
          </div>
        )}
      </div>
    </div>
  );
}

/* Inline Workspace Dashboard Aesthetic Stylesheet */
const styles = {
  container: { padding: "30px", fontFamily: "'Segoe UI', Roboto, sans-serif", backgroundColor: "#f8f9fa", minHeight: "100vh" },
  center: { display: "flex", justifyContent: "center", alignItems: "center", height: "100vh", fontSize: "18px", fontWeight: "600" },
  headerRow: { display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "15px" },
  backBtn: { backgroundColor: "#fff", border: "1px solid #ccc", padding: "8px 16px", borderRadius: "6px", cursor: "pointer", fontWeight: "600", transition: "0.2s" },
  badge: { color: "#fff", padding: "6px 14px", borderRadius: "20px", fontWeight: "bold", fontSize: "13px" },
  mainTitle: { fontSize: "32px", color: "#111", margin: "0 0 5px 0", fontWeight: "700" },
  subtitle: { fontSize: "16px", margin: "0 0 30px 0" },
  dashboardGrid: { display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(450px, 1fr))", gap: "25px" },
  card: { backgroundColor: "#fff", border: "1px solid #e0e0e0", borderRadius: "10px", padding: "24px", boxShadow: "0 4px 6px -1px rgba(0,0,0,0.05)" },
  cardTitle: { margin: "0 0 10px 0", fontSize: "18px", color: "#1a237e", fontWeight: "600" },
  divider: { border: "0", height: "1px", backgroundColor: "#eee", marginBottom: "18px" },
  table: { width: "100%", borderCollapse: "collapse" },
  label: { padding: "10px 0", color: "#666", fontWeight: "500", fontSize: "15px", width: "40%" },
  val: { padding: "10px 0", color: "#111", fontWeight: "600", fontSize: "15px" },
  contactSection: { backgroundColor: "#fdfdfd", border: "1px dashed #e0e0e0", borderRadius: "8px", padding: "15px", lineHeight: "1.6" },
  contactSub: { margin: "0 0 10px 0", color: "#0d47a1", borderBottom: "1px solid #eee", paddingBottom: "5px" },
  teamGrid: { display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))", gap: "20px", marginTop: "10px" },
  teamNode: { backgroundColor: "#f4f6f9", padding: "15px", borderRadius: "8px", borderLeft: "4px solid #1565c0" },
  roleLabel: { fontSize: "12px", color: "#555", textTransform: "uppercase", fontWeight: "700", display: "block", marginBottom: "5px" },
  personName: { fontSize: "15px", margin: "0", fontWeight: "600", color: "#222" },
  noTeamAlert: { padding: "20px", textAlign: "center", backgroundColor: "#fffde7", color: "#f57f17", borderRadius: "8px", fontWeight: "500", border: "1px solid #fff59d" }
};
